import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useInvoices} from '../hooks/useInvoices';


interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

export const DeleteRecordButton = ({selectedIds, onDeleteComplete}: DeleteRecordButtonProps) => {

    const {deleteRecords} = useInvoices();

    const disabled = selectedIds.length === 0;

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={selectedIds.length}
        handleConfirm={() => {
            deleteRecords(selectedIds);
            onDeleteComplete?.();
        }}/>);
};
